<template>
  <div>
    <input
      accept="image/*"
      ref="uploadInput"
      @change="handleChange"
      type="file"
      :style="{ width: 0, height: 0 }"
      name="file"
      class="el-upload__input upload-input"
    />
    <div v-if="imageUrl">
      <!-- <img
        :src="imageUrl"
        style="width:360px;height:180px;border:1px solid #ccc"
      /> -->
      <canvas
        :id="canvasId"
        style="border: 1px solid #ccc"
        @contextmenu="handleContextMenu"
      ></canvas>
      <el-link
        type="info"
        style="margin-left: 10px"
        @click="handleReset"
        :disabled="disabled"
        >重签</el-link
      >
    </div>
    <div v-else>
      <el-button
        :disabled="disabled"
        v-if="widget.options.isUpdate"
        type="primary"
        icon="el-icon-upload"
        style="margin-right: 10px"
        @click="handleUpload"
        :loading="loading"
        >上传签名照</el-button
      >
      <span v-if="widget.options.isUpdate">或</span>
      <el-button
        :disabled="disabled"
        type="primary"
        icon="el-icon-edit"
        @click="showEsign"
        :loading="loading"
        >手写签名
      </el-button>
      或
      <el-button
        :disabled="disabled"
        style="margin-right: 10px"
        type="primary"
        icon="el-icon-edit"
        :loading="loading"
        @click="hanldeSelect"
        >选择签名</el-button
      >
    </div>
    <el-dialog
      title="选择签名"
      :visible.sync="selectVisible"
      append-to-body
      :width="'620px'"
      destroy-on-close
    >
      <div style="display: flex; justify-content: center">
        <List
          :current-data="currentData"
          @change="handleSelectChange"
          @set-default="handleSetDefault"
        />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDefaultCancel">取 消</el-button>
        <el-button
          type="primary"
          @click="handleDefaultSubmit"
          :loading="defaultBtnLoading"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :title="isQR ? '二维码签名' : '手写签名'"
      :visible.sync="esignVisible"
      append-to-body
      center
      :width="'500px'"
    >
      <div style="display: flex; justify-content: center">
        <div v-if="isQR">
          <div style="margin-bottom: 15px; color: #ff696a">
            提示：请用app扫码进行签名
          </div>
          <QRCode :moduleId="widget.model" :taskid="taskid" :uuid="uuid" />
        </div>
        <div
          v-else
          style="
            border: 1px solid #ccc;
            margin-bottom: 20px;
            width: 360px;
            height: 180px;
          "
        >
          <vue-esign
            v-show="!imageUrl && !disabled"
            :width="345"
            :height="184"
            ref="esign"
            :isCrop="isCrop"
            :lineWidth="lineWidth"
            :lineColor="lineColor"
            :bgColor.sync="bgColor"
          />
          <img width="360px" height="180px" v-show="imageUrl" :src="imageUrl" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" :loading="qrbtnLoading" @click="changeType"
          >切换{{ isQR ? '手写签名' : '二维码' }}</el-button
        >
        <el-button type="primary" @click="save" :loading="qrbtnLoading"
          >完成</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from './request'
import { config } from '../../config/config'
import QRCode from './QRCode'
import List from './list'
import formUtils from '../../util/formUtils'
import alertUtils from '../../util/alertUtils'
export default {
  props: ['widget', 'disabled', 'value', 'nodeConfig'],
  components: {
    QRCode,
    List,
  },
  data() {
    return {
      flag: true,
      lineWidth: this.widget.options.lineWidth,
      lineColor: '#000000',
      bgColor: '',
      dataModel: '',
      isCrop: false,
      esignVisible: false,
      selectVisible: false,
      isQR: true,
      imageUrl: '',
      loading: false,
      qrbtnLoading: false,
      taskid: '',
      uuid: '',
      canvasId: '',
      defaultBtnLoading: false,
      // 当前选中签名
      currentData: {},
    }
  },
  created() {
    this.taskid = formUtils.getQueryVariable('taskid')
    this.canvasId = 'esign' + this.generateUUID()
  },
  mounted() {
    if (this.value && this.value.type && this.value.id) {
      this.querySign(
        this.widget.model,
        this.value.type,
        this.value.id,
        this.value.taskid
      )
    }
    /**
     * 流程设计 数据权限 电子签名配置默认签名
     */
    if (
      this.nodeConfig &&
      this.nodeConfig[this.widget.model] &&
      this.nodeConfig[this.widget.model].initial === 'defaultSign'
    ) {
      this.handleGetDefaultSign()
    }
  },
  watch: {
    dataModel(val) {
      this.$emit('input', val)
      this.$emit('change')
    },
    value: {
      deep: true,
      handler(val) {
        this.dataModel = val
      },
    },
    imageUrl(val) {
      if (!val) {
        return
      }
      this.$nextTick(() => {
        const canvas = document.querySelector(`#${this.canvasId}`)

        const img = new Image()
        img.src = val
        const c = canvas.getContext('2d')

        // 图片初始化完成后调用
        img.onload = function () {
          // 将canvas的宽高设置为图像的宽高
          canvas.width = 360
          canvas.height = 180
          // canvas画图片
          c.drawImage(img, 0, 0, 360, 180)
        }
      })
    },
  },
  methods: {
    changeType() {
      this.isQR = !this.isQR
    },
    handleContextMenu(e) {
      e.preventDefault()
    },
    generateUUID() {
      const s = []
      const hexDigits = '0123456789abcdef'
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = '-'

      const uuid = s.join('')
      return uuid
    },
    handleUpload() {
      this.$refs.uploadInput.click()
    },
    handleChange() {
      const files = this.$refs.uploadInput.files
      const file = files[0]
      const is50kb = file.size <= 100 * 1024 // 限制小于50kb
      if (!is50kb) {
        alertUtils.alertWarning(
          `图片大小限制为100kb,该图片尺寸为${(file.size / 1024).toFixed(2)}kb`
        )
        return
      }
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        // 每次重签都需要生成新的uuid
        this.uuid = this.generateUUID()
        this.addSign(reader.result, true)
        // this.dataModel = reader.result
      }
      this.$refs.uploadInput.value = []
    },
    addSign(img, library) {
      const data = {
        moduleId: this.widget.model,
        sign: img,
        library: library,
        taskId: this.taskid,
        id: this.uuid,
      }
      this.loading = true
      request({
        url: config.baseAPI + '/v1/sign/add',
        method: 'post',
        data,
      })
        .then(res => {
          alertUtils.alertSuccess(res.msg)
          this.imageUrl = img
          this.dataModel = {
            id: res.data.id,
            type: res.data.type,
            taskid: this.taskid,
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleReset() {
      this.imageUrl = ''
      this.dataModel = ''
    },
    handleSelectChange(item) {
      const { id, type, sign } = item
      this.imageUrl = sign
      this.dataModel = {
        id: id,
        type: type,
      }
      this.selectVisible = false
    },
    handleSetDefault(item) {
      this.currentData = item
    },
    cancel() {
      this.esignVisible = false
    },
    save() {
      this.isQR ? this.saveByQR() : this.saveByEsign()
    },
    saveByEsign() {
      this.$refs.esign
        .generate()
        .then(res => {
          const library = !this.taskid // 发起任务时，没有taskid，需要将签名入库
          this.addSign(res, library)
          this.esignVisible = false
        })
        .catch(() => {
          this.$alert('请先签名')
        })
    },
    saveByQR() {
      this.querySign(this.widget.model, '', this.uuid, this.taskid).finally(
        () => {
          this.esignVisible = false
        }
      )
    },
    querySign(moduleId, type, id, taskId) {
      const data = {
        moduleId: moduleId,
        type: type,
        id: id,
        taskId: taskId,
      }
      return request({
        url: config.baseAPI + '/v1/sign/query',
        method: 'get',
        params: data,
      }).then(res => {
        this.imageUrl = res.data.sign
        this.dataModel = {
          id: res.data.id,
          type: res.josnObj.type,
          taskid: taskId,
        }
      })
    },
    showEsign() {
      this.esignVisible = true
      this.uuid = this.generateUUID()
      if (this.isQR) {
        return
      }
      this.$nextTick(() => {
        this.$refs.esign.reset()
      })
    },
    hanldeSelect() {
      this.selectVisible = true
    },
    confirmSelect() {},
    /**
     * 获取默认签名
     */
    handleGetDefaultSign() {
      request({
        url: config.baseAPI + '/v1/sign/defaultSign?defaultSign=1',
        method: 'get',
      })
        .then(res => {
          const { id, type, sign } = res.data
          this.imageUrl = sign
          this.dataModel = {
            id: id,
            type: type,
            // taskid: taskId,
          }
          this.currentData = res.data
        })
        .finally(() => {})
    },
    /**
     * 设置默认签名
     */
    handleDefaultSubmit() {
      const { status, id } = this.currentData
      this.defaultBtnLoading = true
      const data = {
        status,
        id,
        defaultSign: '1',
      }
      request({
        url: config.baseAPI + '/v1/sign/updateDefaultSign',
        method: 'post',
        data,
      })
        .then(res => {
          alertUtils.alertSuccess(res.msg)
          const { sign, type, id } = this.currentData
          this.imageUrl = sign
          this.dataModel = {
            type: type,
            id: id,
          }
          this.defaultBtnLoading = false
          this.selectVisible = false
        })
        .finally(() => {})
    },

    handleDefaultCancel() {
      this.selectVisible = false
    },
  },
}
</script>

<style></style>
